import {PullRequestStateIcons} from '@github-ui/issue-pr-state/Icons'
import {PullRequestState} from '../types'
import type {Icon} from '@primer/octicons-react'

export function StateIcon({state, ...props}: {state: PullRequestState; className?: string}) {
  let IconComponent: Icon
  if (state === PullRequestState.Queued) {
    // TODO: Resolve inconsistent representation of queued state
    IconComponent = PullRequestStateIcons.IN_MERGE_QUEUE
  } else {
    IconComponent = PullRequestStateIcons[state]
  }

  return <IconComponent {...props} />
}
